export default "__VITE_ASSET__c7d8416c__"